module.exports = __webpack_public_path__ + "img/google-maps.5616d703.svg";